// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorPopover-cls1_DYS","cls2":"AuthorPopover-cls2_GR7 AuthorPopover-cls1_DYS"};